import React from "react";
import ChatBotBtn from "./1-chatbot";
import CyberLawBtn from "./2-cyber-law";
import CyberIntelBtn from "./3-cyber-intel";

const WidgetBtn = () => {
  return (
    <>
      <div
        className="position-absolute bottom-0 end-0"
        style={{ padding: 70, paddingBottom: 180 }}
      >
        <ChatBotBtn />
      </div>
      <div
        className="position-absolute bottom-0 end-0"
        style={{ padding: 70, paddingBottom: 120 }}
      >
        <CyberLawBtn />
      </div>
      
      <div
        className="position-absolute bottom-0 end-0"
        style={{ padding: 70, paddingBottom: 60 }}
      >
        <CyberIntelBtn />
      </div>
    </>
  );
};

export default WidgetBtn;